var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"public_main_bgc"},[_c('div',{staticClass:"GroupCreateLive"},[_vm._m(0),_c('CreateLive')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"newCourseNav"},[_c('p',[_vm._v(" 当前位置：研修中心 > 教研中心 > "),_c('span',{staticStyle:{"color":"#ff8201"}},[_vm._v("创建直播")])])])
}]

export { render, staticRenderFns }